import './CurrentBets.scss';
import editIcon from '../../assets/icons/edit.svg';
import bettingIcon from '../../assets/icons/betting.svg';
import { observer } from 'mobx-react';
import { betStore, roundStore, userStore, useTranslation } from '../../platform/stores';
import { RoundStatus } from '../../platform/enums/round-status';

export const CurrentBets = observer(() => {
  const t = useTranslation();
  const { currentBets, setBetToEdit } = betStore;
  const { roundStatus, openedNumbers } = roundStore;

  return (
    <div className="current-bet-component">
      {
        currentBets.length
          ?
          <div className="current-bet-item">
            <div className="row">
              <div className="first">{t('CURRENT_BETS_TOTAL_BETS_COUNT')}</div>
              <div className="second">{currentBets.length}</div>
            </div>
            <div className="hr"></div>
            <div className="row">
              <div className="first">{t('CURRENT_BETS_TOTAL_BETS_AMOUNT')}</div>
              <div className="second">{currentBets.reduce((acc, el) => acc + el.amount, 0).toFixed(2)}</div>
            </div>
            <div className="hr"></div>
            <div className="tickets">
              {
                currentBets.map((item) =>
                  <div className="ticket" key={item.id}>
                    <div className="row">
                      <div className="first">{t('CURRENT_BETS_TICKET_ID', item.id)}</div>
                      <div className="second">
                        {
                          roundStatus === RoundStatus.Started && item.userId == userStore.id
                            ?
                            <div className="edit-icon flex-center cursor-pointer">
                              <img src={editIcon} alt="Edit icon" onClick={() => setBetToEdit(item)}/>
                            </div>
                            :
                            <></>
                        }
                      </div>
                    </div>
                    <div className="hr"></div>
                    <div className="numbers">
                      {
                        item.numbers.map((number) =>
                          <div className={`number flex-center ${openedNumbers.includes(number) ? 'winner' : ''}`}
                               key={'current-bets-' + item.id + '-' + number}>
                            {number}
                          </div>
                        )
                      }
                    </div>
                    <div className="hr"></div>
                    <div className="row">
                      <div className="first">{t('CURRENT_BETS_TICKET_BET', item.amount)}</div>
                      <div className="second">{t('CURRENT_BETS_TICKET_WIN', item.winAmount || '-')}</div>
                    </div>
                  </div>
                )
              }
            </div>
          </div>
          :
          <div className="empty-bets flex-center">
            <div>
              <div className="flex-center">
                <img src={bettingIcon} alt="Betting icon"/>
              </div>
              <div className="title">{t('CURRENT_BETS_NO_BETS')}</div>
              <div className="description">{t('CURRENT_BETS_PLEASE_PLACE_YOUR_BET')}</div>
            </div>
          </div>
      }
    </div>
  );
});
